import { createSchemaFromIece } from './createSchemaFromIece';
import { setSchemaProperty } from './setSchemaProperty';

/*
  Permite crear un json schema (para poder validar un json de datos)
  1) se crea la estructura de datos usando como base la iece (=json de la in4)
  2) se completa esta estructura con el view que es el que tiene las validaciones
  NOTA: para el tipo "packages" hay un tratamiento especial ya que tiene distintas estructuras según su tipo.

  @param iece: json de la in4 - necesario para poder generar todos los datos en el orden correcto ya que el view puede ser incompleto
  @param view: view MERGED - tiene que ser el view completo mergeado, ya que se usa para recuperar los validadores de la in4 + del view
*/

/**
 * @typedef SchemaProperty
 * @property {string} title el titulo del campo
 * @property {string} model el modelo
 * @property {string} type data|object|array
 * @property {boolean|string} required Indica si obligatorio
 * @property {Object} section la sección madre del campo, para organizar la vista para el usuario
 * @property {string} section.name el name "clave" de la sección
 * @property {string} section.title el titulo de la sección
 * @property {Object} validators Lista de validadores en formato ej: `{required: true, maxLength: 10}`
 *
 */

export default function create(iece, view) {
  const schema = createSchemaFromIece(iece);
  mergeView(view, schema);
  return schema;
}

// aplica los validadores definidos en el view mergeado (=> iece+view)
function mergeView(view, schema) {
  const getSchemaPropertyInitial = getSchemaPropertyFactory(schema);
  //
  view.properties &&
    view.properties.map(section => {
      flatmap(section, section, getSchemaPropertyInitial);
    });

  function flatmap(property, section, getSchemaProperty) {
    // si tipo "packages" ej. 'CAB.EMB'
    if (property.type && property.type === 'packages') {
      const schemaProperty = getSchemaProperty(property.model),
        modelBase = property.model;
      property.properties.forEach(viewProperty => {
        // para cada type/level
        const { type, level } = viewProperty.metadata;
        schemaProperty[`properties${type}`] = schemaProperty[`properties${type}`] || {};
        schemaProperty[`properties${type}`][level] = schemaProperty[`properties${type}`][level] || {};

        const schemaProperties = schemaProperty[`properties${type}`][level],
          getSchemaPropertyPackages = getSchemaPropertyFactory(schemaProperties, modelBase); // para recuperar el schemaProperty correspondiente al tipo/nivel
        flatmap(viewProperty, section, getSchemaPropertyPackages);
      });
    } else {
      // para todos los otros tipos
      property.properties &&
        property.properties.map(viewProperty => {
          viewProperty.metadata = viewProperty.metadata || {};
          if (viewProperty.type !== 'hidden' && viewProperty.model) {
            setSchemaProperty(getSchemaProperty(viewProperty.model), viewProperty, section);
          }
          flatmap(viewProperty, section, getSchemaProperty);
        });
    }
  }
}

function getSchemaPropertyFactory(schema, modelBase = '') {
  return function getSchemaProperty(model) {
    const splitted = model
      // ajuste para tipo `packages`
      .replace(modelBase ? `${modelBase}.` : '', '')
      // // 'CAB.ELE[0].TEST[2]' --> "CAB.ELE.0.TEST.2"
      // .replace(/\[([0-9]*)\]/g, '.$1')
      .split('.');
    const end = splitted.length - 1;

    let currentModel = '';

    return splitted.reduce((acc, cur, i) => {
      currentModel += `${currentModel ? '.' : ''}${cur}`;
      acc[cur] = acc[cur] || {
        model: currentModel,
      };

      if (end === i) {
        return acc[cur];
      }

      acc[cur].properties = acc[cur].properties || {};
      return acc[cur].properties;
    }, schema);
  };
}
